module.exports = __webpack_public_path__ + "img/estado-alert.7eb25087.svg";